import { render, staticRenderFns } from "./ProductPayments.vue?vue&type=template&id=946e82be&"
import script from "./ProductPayments.vue?vue&type=script&lang=js&"
export * from "./ProductPayments.vue?vue&type=script&lang=js&"
import style0 from "./ProductPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports